import React, {useState} from "react";
import showToast from "../../../utils/notification";
import {Button, Modal} from "react-bootstrap";

interface ConfirmRejectBadAddressModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: () => Promise<void>;
}

const ConfirmRejectBadAddressModal: React.FC<ConfirmRejectBadAddressModalProps> = ({
                                                                           show,
                                                                           onHide,
                                                                           onConfirm,
                                                                       }) => {
    const [isLoading, setIsLoading] = useState(false);
    

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Bad Address</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to reject current request as Bad Address?  This will automatically fail packages for
                this stop and will remove stop from the stop list in the driver app.  Driver will need to return packages to hub.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={onConfirm}>
                    Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmRejectBadAddressModal;